// extracted by mini-css-extract-plugin
module.exports = {"dialog":"zgFLuuhSiL1lVpZRB8orW","subHeader":"_1KtiwouWIqyO4w9ANvpVNW","setDefault":"_3geNrzr_Xt08bOJecrAT4c","input":"_3X-ja4efMr6APJ_wQYRvP3"};